import React from "react";
import cardBackImg   from '../../images/card-back.png';
import cvsBackImg    from '../../images/cvs-back.png';
// JSX card-back components kept but replaced by plain images for NuLifeSpan/CVS
// import { NuLifeSpanCardBack } from './Cards/NuLifeSpanCard';
// import { CVSCardBack }        from './Cards/CVSCard';
import { WalmartCardBack } from './Cards/WalmartCard';

/**
 * CardBack
 * Renders the appropriate card-back for a given card type.
 *
 * For NuLifeSpan (default) and CVS: a plain <img> from the static card images.
 * For Walmart: unchanged JSX component.
 *
 * Wallet functionality (Apple/Google pass) is handled at the page level
 * (ShareCard.jsx) and is unaffected by this change.
 */
function CardBack({ cardData, className }) {
    const cardType = cardData?.classnames;

    // Walmart stays as JSX
    if (cardType === 'walmart_card') {
        return <WalmartCardBack className={className} />;
    }

    // CVS: plain image back
    if (cardType === 'cvs_card') {
        return (
            <img
                src={cvsBackImg}
                alt="Prescription Savings Card — Back"
                style={{ borderRadius: 16, display: 'block', height: 'auto', width: '100%' }}
                className={className}
            />
        );
    }

    // Default (NuLifeSpan / glic_card): plain image back
    return (
        <img
            src={cardBackImg}
            alt="Prescription Savings Card — Back"
            style={{ borderRadius: 16, display: 'block', height: 'auto', width: '100%' }}
            className={className}
        />
    );
}

export default CardBack;
